var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProjetoProdutoImobiliario(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 53,
    viewBox: "0 0 54 53",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_838_22714",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 54,
    height: 53
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 53,
    height: 53,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_838_22714)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.6247 43.9967L20.3747 39.3593L11.6348 42.7397C11.0685 42.9492 10.5433 42.8876 10.0592 42.555C9.57508 42.2223 9.33301 41.7545 9.33301 41.1514V14.1418C9.33301 13.7482 9.42856 13.3887 9.61965 13.0631C9.81074 12.7375 10.0889 12.511 10.4541 12.3836L20.3747 9.00317L33.6247 13.6407L42.3646 10.2602C42.9308 10.0507 43.456 10.0911 43.9401 10.3812C44.4243 10.6714 44.6663 11.1039 44.6663 11.6786V39.028C44.6663 39.4499 44.5496 39.8165 44.316 40.1279C44.0824 40.4394 43.7689 40.6588 43.3754 40.7862L33.6247 43.9967ZM32.5205 41.3043V15.4668L21.4788 11.6107V37.4482L32.5205 41.3043Z",
    fill: "#00BCD4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjetoProdutoImobiliario);
export default __webpack_public_path__ + "static/media/projeto-produto-imobiliario.13ca84fcd566fe98f6b22e0a40fa8c67.svg";
export { ForwardRef as ReactComponent };